import { Container, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import { useState } from 'react'
import { Btn, H4, H6, Image, P } from '../../../AbstractElements';
import { EmailAddress, EmailsPlaceHolder, FirstName, LastName, UpdateProfile, YourName } from '../../../utils/Constant';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../ReduxToolkit/Hooks';
import { updateUserAction } from '../../../Api/auth';
import { setUser } from '../../../ReduxToolkit/Reducers/UserSlice';
import { toast } from 'react-toastify';

const EditProfileContainer = () => {
  const user = useAppSelector(state => state.user)
  const [firstname, setFirstName] = useState(user.firstname);
  const [lastname, setLastName] = useState(user.lastname);
  const [email, setEmail] = useState(user.email);
  const [isEditable, setIsEditable] = useState(false)
  const [phonenumber, setPhoneNumber] = useState(user.phonenumber);
  const navigate = useNavigate();
  const dispatch = useAppDispatch()
  const updateUserHandle = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const _user = {
      firstname, lastname, email, phonenumber
    }
    const { user, response } = await updateUserAction(_user)
    if (user !== undefined) {
      dispatch(setUser(user))
      setIsEditable(false)
      toast.success("Profile Updated Successfully!");

    }
    else {
      const _response: any = response
      if (_response?.response)
        toast.error(_response.response.data.message)
      else
        toast.error("Update failed!")
    }
  };

  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <Col xs="12" className="p-0">
          <div className="login-card login-dark" style={{ background: 'none', minHeight: 'calc(100vh - 80px)', paddingBottom: '120px' }}>
            <div>
              <div className="login-main">
                <Form className="theme-form" onSubmit={(event) => updateUserHandle(event)}>
                  <H4>{"Edit Profile"}</H4>
                  <P>{"Enter your personal details to update profile"}</P>
                  <FormGroup>
                    <Label className="col-form-label pt-0">{YourName}</Label>
                    <Row className="g-2">
                      <Col xs="6">
                        <Input type="text" required disabled={!isEditable} value={firstname} placeholder={FirstName} onChange={(event) => setFirstName(event.target.value)} />
                      </Col>
                      <Col xs="6">
                        <Input type="text" required disabled={!isEditable} value={lastname} placeholder={LastName} onChange={(event) => setLastName(event.target.value)} />
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">{EmailAddress}</Label>
                    <Input type="email" required disabled={!isEditable} placeholder={EmailsPlaceHolder} value={email} onChange={(event) => setEmail(event.target.value)} />
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">{"Phone Number"}</Label>
                    <Input type="text" disabled={!isEditable} placeholder={"Phone Number"} required value={phonenumber} onChange={(event) => setPhoneNumber(event.target.value)} />
                  </FormGroup>
                  {isEditable ?
                    <FormGroup className="mb-0">
                      <Row>
                        <Col md='6'>
                          <Btn block color="primary" className="w-100">{"Save"}</Btn>
                        </Col>
                        <Col md='6'>
                          <div className="w-100 btn btn-danger" onClick={() => {
                            setIsEditable(false)
                            setFirstName(user.firstname)
                            setLastName(user.lastname)
                            setEmail(user.email)
                            setPhoneNumber(user.phonenumber)
                          }}
                          >{"Cancel"}</div>
                        </Col>
                      </Row>
                    </FormGroup> :
                    <FormGroup className="mb-0">
                      <div className="w-100 btn btn-secondary" onClick={() => setIsEditable(true)}>{"Edit Profile"}</div>
                    </FormGroup>
                  }
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default EditProfileContainer